import React from 'react';

import { BackToTop } from '@ulta/core/components/BackToTop/BackToTop';
import { ARIA_LIVE_LOCATION, AriaLiveRegion } from '@ulta/core/providers/AriaLiveRegionProvider/AriaLiveRegionProvider';
import { useDeviceInflection } from '@ulta/core/providers/InflectionProvider/InflectionProvider';

export const ContentContainer = function( props ){
  const { inflection } = useDeviceInflection();

  return (
    <div className='ContentContainer'>
      { props.children }
      { inflection.DESKTOP && <BackToTop /> }
      <AriaLiveRegion location={ ARIA_LIVE_LOCATION.Page } />
    </div>
  );
};

export default ContentContainer;
